/** GrowthBook experiment key configured in GrowthBook as `invite-page-experience`. */
export const INVITE_PAGE_EXPERIMENT_KEY = 'invite-page-experience' as const;

export type InvitePageExperience = 'A' | 'B';

function inviteVariationIdFromPayload(value: unknown): string | undefined {
  if (typeof value === 'string') {
    return value;
  }
  if (value !== null && typeof value === 'object') {
    const raw = value as { variationId?: unknown, variationid?: unknown };
    const id = raw.variationId ?? raw.variationid;
    return typeof id === 'string' ? id : undefined;
  }
  return undefined;
}

/** Normalize remote flag values; unknown values fall back to control for safe rollout / rollback. */
export function normalizedInviteExperimentValue(value: unknown): InvitePageExperience {
  const variationId = inviteVariationIdFromPayload(value);
  return variationId === 'B' ? 'B' : 'A';
}

/**
 * GrowthBook experiment `surface-invite-button-anywhere`.
 * Control keeps the Invite nav item and the legacy invite dialog.
 * B hides that nav item and opens Invite Page B instead.
 */
export const SURFACE_INVITE_BUTTON_ANYWHERE_FLAG = 'surface-invite-button-anywhere' as const;

export function isSurfaceInviteButtonAnywhereB(value: unknown): boolean {
  return normalizedInviteExperimentValue(value) === 'B';
}
